import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconWithDescriptionItem = (props) => {
    const { col, icon, title, text, iconsWithBackground } = props
    const itemClassName = classNames("description-and-icon__item col-xs-12",
        {
            [`col-sm-${col}`]: col
        })

    const iconClassName = classNames("description-and-icon__item__icon icon",
        {
            [icon]: icon,
            'description-and-icon__item__icon--with-background': iconsWithBackground
        })

    return (
        <div className={itemClassName}>
            <i className={iconClassName} />
            <div className="description-and-icon__item__text">
                <div className="description-and-icon__item__text__title">
                    {title}
                </div>
                <div className="description-and-icon__item__text__description">
                    {text}
                </div>
            </div>
        </div>
    )
}

IconWithDescriptionItem.propTypes = {
    col: PropTypes.number,
    icon: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    iconsWithBackground: PropTypes.bool
}

IconWithDescriptionItem.defaultProps = {
    col: 3,
    icon: '',
    text: '',
    title: '',
    iconsWithBackground: false
}

export { IconWithDescriptionItem };